<template>
  <vk-modal-body>
    <services-modal-header>
      {{ hierarchy.name }}
    </services-modal-header>
    <vk-modal-content>
      <div class="layout gap-1">
        <div
            v-for="service in hierarchy.services"
            :key="service.service_identifier"
            class="layout-item is-12 is-6:t">
          <div
              :selenium="`service-${service.service_display_name.replace(/ /g, '-').toLowerCase()}`"
              class="link ellipsize"
              @click="$store.commit('homepage/request/setSelectedService', service);">
            {{ service.service_display_name }}
          </div>
        </div>
      </div>
    </vk-modal-content>
  </vk-modal-body>
</template>
<script>
import ServicesModalHeader from './components/ServicesModalHeader';
import ServicesModalBody from './components/ServicesModalBody';

export default {
  name: 'hierarchy-modal',
  components: {
    ServicesModalHeader,
    ServicesModalBody,
  },
  props: {
    hierarchy: {
      type: Object,
      required: true,
    },
  },
};
</script>
